import { render, staticRenderFns } from "./naj-search-box.vue?vue&type=template&id=3e5787c4&scoped=true&"
import script from "./naj-search-box.vue?vue&type=script&lang=js&"
export * from "./naj-search-box.vue?vue&type=script&lang=js&"
import style0 from "./naj-search-box.vue?vue&type=style&index=0&id=3e5787c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5787c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
